<div class="container">
    <app-header></app-header>
</div>

<main role="main" class="container">
    <div class="row">
        <div class="col-md-8 blog-main">
            <div class="blog-post">

                <h2 class="blog-post-title">Grußwort</h2>
                <h3>des Oberbürgermeisters der Stadt Nürnberg <br>
                    zum jüdischen Neujahr 5786</h3>
                <img src="assets/img/koenig.jpg" class="rounded float-left" height="360px"
                    style="padding-right: 15px; padding-bottom: 15px" alt="Marcus Koenig">
                <p>Liebe Nürnbergerinnen und Nürnberger jüdischen Glaubens,</p>
                <p>zum jüdischen Neujahr, Rosh haShana, möchte ich Ihnen im Namen der Stadt
                    Nürnberg meine herzlichsten Glückwünsche übermitteln. Dieses bedeutende Fest
                    markiert den Beginn eines neuen Jahres im jüdischen Kalender und ist eine Zeit der
                    Reflexion, des Innehaltens und der Hoffnung. Es ist eine Gelegenheit, das
                    vergangene Jahr Revue passieren zu lassen, um daraus zu lernen, und mit
                    Zuversicht und guten Vorsätzen in das kommende Jahr zu starten.</p>
                <p>Rosh haShana erinnert uns auch an die Werte des Friedens, der Versöhnung und
                    des Neuanfangs. Es ist eine Zeit, in der Familien, Freunde und Gemeinschaft
                    zusammenkommen, um gemeinsam zu feiern, zu beten und sich gegenseitig alles
                    Gute zu wünschen. Möge das Jahr 5786 für alle Menschen in Nürnberg und darüber
                    hinaus Gesundheit, Glück, Erfolg und vor allem Frieden bringen.</p>
                <p>Nürnberg ist eine Stadt, die von Vielfalt, Toleranz und gegenseitigem Respekt lebt.
                    Das jüdische Leben ist ein wertvoller Bestandteil unserer Gemeinschaft, der unsere
                    Stadt bereichert und mit Leben erfüllt. Ich bin dankbar für die lebendige jüdische
                    Gemeinde in Nürnberg, die mit ihrer Geschichte, Kultur und ihren Traditionen einen
                    wichtigen Beitrag zu unserem gesellschaftlichen Miteinander leistet. Mögen die
                    kommenden Monate von gegenseitigem Verständnis, Zusammenarbeit und einem
                    verstärkten Austausch geprägt sein.</p>
                <p>Lassen Sie uns gemeinsam für ein respektvolles und friedliches Miteinander
                    eintreten. Indem wir die Werte der Toleranz, des Respekts und der Solidarität
                    hochhalten, können wir eine Gesellschaft gestalten, in der sich alle Menschen wohl
                    und willkommen fühlen. Ich wünsche Ihnen und Ihren Familien ein gesegnetes,
                    friedliches und erfolgreiches neues Jahr 5786. Möge es Ihnen Gesundheit, Freude
                    und viele schöne Momente bringen.</p>
                <p>שָׁנָה טוֹבָה וּמְתוּקָה – Ich wünsche allen ein gutes und gesegnetes neues
                    Jahr!</p>
                <p>Mit herzlichen Grüßen</p>
                <p>Marcus König, <br />Oberbürgermeister</p>
            </div><!-- /.blog-post -->

        </div><!-- /.blog-main -->

        <aside class="col-md-4 blog-sidebar">
            <app-info-box></app-info-box>
        </aside><!-- /.blog-sidebar -->
    </div><!-- /.row -->

</main><!-- /.container -->

<app-related-articles></app-related-articles>